@if (userInfos()) {
  <div class="flex-row align-center gap-8"
       (click)="select.emit(userInfos()); openMenu()">
    @if (userInfos().docId) {
      <vl-doc-local
        [deactivateVisu]="deactivateVisu()"
        [docId]="userInfos().docId"
        [width]="imageSize()"
        [height]="imageSize()"
        [readOnly]="true"
      ></vl-doc-local>
    } @else {
      <div class="flex-row border-full align-center justify-center w-32 h-32 body-2"
           [style.background-color]="bgColor()">
        <div [style.color]="textColor()">
          {{ initials() }}
        </div>
      </div>
    }

    @if (!bulle && !inline()) {
      @if (hideNameOnMobile()) {
        <div class="flex-col flex-end profile-text">
          @if (date) {
            <span class="{{fontTitle()}} on-background">{{ userInfos().nom }} {{ userInfos().prenom }}</span>
            <span class="{{fontSubtitle()}} on-background-alt">{{ date | date:'short' }}</span>
          } @else {
            <span class="{{fontTitle()}} on-background">{{ userInfos().prenom }}</span>
            <span class="{{fontSubtitle()}} on-background-alt">{{ userInfos().nom }}</span>
          }
        </div>
      } @else {
        <div class="flex-col flex-end">
          @if (date) {
            <span class="{{fontTitle()}} on-background">{{ userInfos().nom }} {{ userInfos().prenom }}</span>
            <span class="{{fontSubtitle()}} on-background-alt">{{ date | date:'short' }}</span>
          } @else {
            <span class="{{fontTitle()}} on-background">{{ userInfos().prenom }}</span>
            <span class="{{fontSubtitle()}} on-background-alt">{{ userInfos().nom }}</span>
          }
        </div>
      }

    }


    @if (inline()) {
      @if (white()) {
        <div class="flex-col flex-end profile-text">
          <span class="{{fontTitle()}} on-background-reverse profile-text">{{ userInfos().prenom }} {{ userInfos().nom }}</span>
          <span class="{{fontSubtitle()}} on-background-reverse-alt">{{ date | date:'short' }}</span>
        </div>
      } @else {
        @if (hideNameOnMobile()) {
          <div class="flex-col flex-end profile-text">
            <span
              class="{{fontTitle()}} on-background profile-text">{{ userInfos().prenom }} {{ userInfos().nom }}</span>
            <span class="{{fontSubtitle()}} on-background-alt">{{ date | date:'short' }}</span>
          </div>
        } @else {
          <div class="flex-col flex-end profile-text">
            <span
              class="{{fontTitle()}} on-background profile-text">{{ userInfos().prenom }} {{ userInfos().nom }}</span>
            <span class="{{fontSubtitle()}} on-background-alt">{{ date | date:'short' }}</span>
          </div>
        }
      }
    }
  </div>
  <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="buttonMenu" class="hidden"></div>
}


<mat-menu #buttonMenu>
  <div class="w100 p-4 border-box">
    <vl-big-button color=primary
                   (action)="goProfile()"
                   [text]="'user_card.my_profile' | trans"
    />
  </div>
  <div class="w100 p-4 border-box">
    <vl-big-button [icon]="darkMode() ? 'light_mode' : 'dark_mode'"
                   (action)="toggleDarkMode.emit()"
                   [text]="(darkMode() ? 'navbar.light_mode' : 'navbar.dark_mode') | trans"
    />
  </div>
  <div class="w100 p-4 border-box">
    <vl-big-button color=secondary
                   (action)="onLogout()"
                   [text]="'auth.logout' | trans"
    />
  </div>
  <div class="w100 p-4 border-box">
    <vl-big-button color=error
                   (action)="dialogService.open(bugReport)"
                   [text]="'user_card.report_problem' | trans"
    />
  </div>
</mat-menu>

<ng-template #bugReport let-dialogRef="dialogRef">
  <div class="justup-dialog-medium">
    <vl-header-dialog (close)="dialogRef?.close()">
      {{ 'user_card.bug_title' | trans }}
    </vl-header-dialog>
    <div class="justup-dialog-content">
      <div class="flex-col gap-24 w100">
        <div class="justup-card-warning flex-col gap-12">
          <div class="flex-col w100">
            <span class="body-2">{{ 'user_card.bug_desc1' | trans }}</span>
            <span class="body-2">{{ 'user_card.bug_desc2' | trans }}</span>
          </div>
        </div>
        <div class="justup-card-canvas flex-col w100 gap-24">
          <div class="flex-col">
            <span class="body-2">{{ 'user_card.recording_desc1' | trans }}</span>
            <span class="body-2">{{ 'user_card.recording_desc2' | trans }}</span>
            <span class="body-2">{{ 'user_card.recording_desc3' | trans }}</span>
          </div>
          <div class="flex-row gap-24 wrap">
            <vl-record-buttons type="button"/>
            <vl-chips class="ml-auto" (action)="ticketService.maximize()"
                      iconLeft="chat">{{ 'user_card.open_chat' | trans }}
            </vl-chips>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>

